import { render, staticRenderFns } from "./NewsAttachment.vue?vue&type=template&id=5cbf8592&scoped=true"
import script from "./NewsAttachment.vue?vue&type=script&lang=ts"
export * from "./NewsAttachment.vue?vue&type=script&lang=ts"
import style0 from "./NewsAttachment.vue?vue&type=style&index=0&id=5cbf8592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf8592",
  null
  
)

export default component.exports